import { get, post, put, del } from './client.js';
import type {
  Resource,
  ResourceCategory,
  ResourceListResponse,
  CreateResourceRequest,
  UpdateResourceRequest,
} from '../types/index.js';

export const resourceApi = {
  list: (params?: {
    page?: number;
    per_page?: number;
    keyword?: string;
    category_id?: number;
  }) => {
    const q = new URLSearchParams();
    if (params?.page) q.append('page', params.page.toString());
    if (params?.per_page) q.append('per_page', params.per_page.toString());
    if (params?.keyword) q.append('keyword', params.keyword);
    if (params?.category_id !== undefined) q.append('category_id', params.category_id.toString());
    const qs = q.toString();
    return get<ResourceListResponse>(`/resources${qs ? '?' + qs : ''}`);
  },

  get: (id: number) => get<Resource>(`/resources/${id}`),

  create: (data: CreateResourceRequest) => post<Resource>('/resources', data),

  update: (id: number, data: UpdateResourceRequest) =>
    put<Resource>(`/resources/${id}`, data),

  delete: (id: number) => del<{ message: string }>(`/resources/${id}`),
};

export const resourceCategoryApi = {
  list: () => get<{ data: ResourceCategory[] }>('/resource-categories'),
  create: (data: { name: string; is_global?: number }) =>
    post<ResourceCategory>('/resource-categories', data),
  update: (id: number, name: string) =>
    put<ResourceCategory>(`/resource-categories/${id}`, { name }),
  delete: (id: number) => del<{ message: string }>(`/resource-categories/${id}`),
};
